<script lang="ts">
	import { classes } from '$lib/utils';

	export let steps: number;
	export let currentStep: number;
	export let additionalClass = '';

	$: items = Array.from('x'.repeat(steps));
</script>

<div class={classes(additionalClass, 'flex justify-center space-x-1 pb-4')}>
	{#each items as item, i}
		<div class="w-14 h-[6px] bg-purple  {i <= currentStep ? '' : 'opacity-20'}" />
	{/each}
</div>
